import styled from "styled-components";
import React from "react";
import { appState, proposal } from "../../globalState";
import { useSnapshot } from "valtio";
import BackIcon from "./Arrows/back.png";
const days = "Sun Mon Tue Wed Thu Fri Sat".split(" ");
const months = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" ");
export default function HistorySideBar() {
  const snapshot = useSnapshot(appState);

  return (
    <Side
      style={{ transform: snapshot.sideBarOpen ? regularPosition : tiltRight }}
    >
      <BackArrow
        src={BackIcon}
        alt="back"
        onClick={() => (appState.sideBarOpen = false)}
      />
      {proposal.editors
        .sort((a, b) => {
          return a.timestamp < b.timestamp ? 1 : -1;
        })
        .map((editor) => {
          const date = new Date(editor.timestamp.seconds * 1000);
          const month = months[date.getMonth()];
          const dayInMonth = date.getDate();
          const day = days[date.getDay()];
          const hours = date.getHours();
          const minutes = date.getMinutes();
          return (
            <div>
              <Time>
                {day} {dayInMonth} {month} {hours < 10 ? "0" + hours : hours}:
                {minutes < 10 ? "0" + minutes : minutes}
              </Time>
              <User> {editor.user || "Developer"} </User>
            </div>
          );
        })}
    </Side>
  );
}

const BackArrow = styled.img`
  height: 22px;
  width: 22px;
  cursor: pointer;
`;
const User = styled.div`
  color: #707070;
`;

const Time = styled.div`
  color: #707070;
  font-weight: bold;
`;
const Side = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  width: 353px;
  height: 100vh;
  z-index: 10;
  transition: all 0.3s;
  box-shadow: 0 3px 20px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  padding-top: 146px;
  display: flex;
  align-items: start;
  flex-direction: column;
  padding-left: 71px;
  gap: 25px;
`;

const tiltRight = "translateX(400px)";
const regularPosition = "translateX(0px)";
